import { LocalNotifications } from "@capacitor/local-notifications";

export async function requestNotificationPermission() {
  await LocalNotifications.requestPermissions();
}

export async function scheduleDailyNotifications() {
  await LocalNotifications.schedule({
    notifications: [
      {
        id: 1,
        title: "¡Titan Training!",
        body: "Recuerda registrar tu desayuno y tu primer actividad del día 💪",
        schedule: {
          on: { hour: 7, minute: 30 },
          repeats: true
        },
        sound: "default"
      },
      {
        id: 2,
        title: "¡Titan Training!",
        body: "No olvides registrar tu cena y repasar tu progreso del día 🥗",
        schedule: {
          on: { hour: 20, minute: 0 },
          repeats: true
        },
        sound: "default"
      }
    ]
  });
}
